import { render, staticRenderFns } from "./VoidTransactionDetail.vue?vue&type=template&id=5f5c0aab&scoped=true"
import script from "./VoidTransactionDetail.vue?vue&type=script&lang=js"
export * from "./VoidTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./VoidTransactionDetail.vue?vue&type=style&index=0&id=5f5c0aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c0aab",
  null
  
)

export default component.exports